import "react";
function e(e, r) {
  (null == r || r > e.length) && (r = e.length);
  for (var t = 0, n = Array(r); t < r; t++) n[t] = e[t];
  return n;
}
function r(e, r, t) {
  return r in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function t(r) {
  return function (r) {
    if (Array.isArray(r)) return e(r);
  }(r) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(r) || function (r, t) {
    if (r) {
      if ("string" == typeof r) return e(r, t);
      var n = Object.prototype.toString.call(r).slice(8, -1);
      if ("Object" === n && r.constructor && (n = r.constructor.name), "Map" === n || "Set" === n) return Array.from(n);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return e(r, t);
    }
  }(r) || function () {
    throw TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
var n = function () {
  var e;
  function n() {
    !function (e, r) {
      if (!(e instanceof r)) throw TypeError("Cannot call a class as a function");
    }(this, n);
  }
  return e = [{
    key: "equals",
    value: function value(e, r, t) {
      return t && e && "object" == typeof e && r && "object" == typeof r ? this.resolveFieldData(e, t) === this.resolveFieldData(r, t) : this.deepEquals(e, r);
    }
  }, {
    key: "deepEquals",
    value: function value(e, r) {
      if (e === r) return !0;
      if (e && r && "object" == typeof e && "object" == typeof r) {
        var t,
          n,
          i,
          a = Array.isArray(e),
          o = Array.isArray(r);
        if (a && o) {
          if ((n = e.length) !== r.length) return !1;
          for (t = n; 0 != t--;) if (!this.deepEquals(e[t], r[t])) return !1;
          return !0;
        }
        if (a !== o) return !1;
        var u = e instanceof Date,
          c = r instanceof Date;
        if (u !== c) return !1;
        if (u && c) return e.getTime() === r.getTime();
        var l = e instanceof RegExp,
          f = r instanceof RegExp;
        if (l !== f) return !1;
        if (l && f) return e.toString() === r.toString();
        var s = Object.keys(e);
        if ((n = s.length) !== Object.keys(r).length) return !1;
        for (t = n; 0 != t--;) if (!Object.prototype.hasOwnProperty.call(r, s[t])) return !1;
        for (t = n; 0 != t--;) if (i = s[t], !this.deepEquals(e[i], r[i])) return !1;
        return !0;
      }
      return e != e && r != r;
    }
  }, {
    key: "resolveFieldData",
    value: function value(e, r) {
      if (this.isFunction(r)) return r(e);
      if (!e || !r) return null;
      if (-1 === r.indexOf(".")) return e[r];
      for (var t = r.split("."), n = e, i = 0, a = t.length; i < a; ++i) {
        if (null === n) return null;
        n = n[t[i]];
      }
      return n;
    }
  }, {
    key: "isFunction",
    value: function value(e) {
      return !!(e && e.constructor && e.call && e.apply);
    }
  }, {
    key: "findDiffKeys",
    value: function value(e, r) {
      return e && r ? Object.keys(e).filter(function (e) {
        return !r.hasOwnProperty(e);
      }).reduce(function (r, t) {
        return r[t] = e[t], r;
      }, {}) : {};
    }
  }, {
    key: "reorderArray",
    value: function value(e, r, t) {
      var n;
      if (e && r !== t) {
        if (t >= e.length) for (n = t - e.length; n-- + 1;) e.push(void 0);
        e.splice(t, 0, e.splice(r, 1)[0]);
      }
    }
  }, {
    key: "omitKeys",
    value: function value(e, t) {
      return Object.keys(e).filter(function (e) {
        return !t.includes(e);
      }).reduce(function (t, n) {
        var i, a;
        return i = function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {},
              i = Object.keys(n);
            "function" == typeof Object.getOwnPropertySymbols && (i = i.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
              return Object.getOwnPropertyDescriptor(n, e).enumerable;
            }))), i.forEach(function (t) {
              r(e, t, n[t]);
            });
          }
          return e;
        }({}, t), a = null != (a = r({}, n, e[n])) ? a : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(a)) : function (e, r) {
          var t = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t.push.apply(t, n);
          }
          return t;
        }(Object(a)).forEach(function (e) {
          Object.defineProperty(i, e, Object.getOwnPropertyDescriptor(a, e));
        }), i;
      }, {});
    }
  }, {
    key: "findIndexInList",
    value: function value(e, r) {
      var t = -1;
      if (r) {
        for (var n = 0; n < r.length; n++) if (r[n] === e) {
          t = n;
          break;
        }
      }
      return t;
    }
  }, {
    key: "getJSXElement",
    value: function value(e) {
      for (var r = arguments.length, n = Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++) n[i - 1] = arguments[i];
      return this.isFunction(e) ? e.apply(void 0, t(n)) : e;
    }
  }, {
    key: "getPropValue",
    value: function value(e) {
      for (var r = arguments.length, n = Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++) n[i - 1] = arguments[i];
      return this.isFunction(e) ? e.apply(void 0, t(n)) : e;
    }
  }, {
    key: "removeAccents",
    value: function value(e) {
      return e && e.search(/[\xC0-\xFF]/g) > -1 && (e = e.replace(/[\xC0-\xC5]/g, "A").replace(/[\xC6]/g, "AE").replace(/[\xC7]/g, "C").replace(/[\xC8-\xCB]/g, "E").replace(/[\xCC-\xCF]/g, "I").replace(/[\xD0]/g, "D").replace(/[\xD1]/g, "N").replace(/[\xD2-\xD6\xD8]/g, "O").replace(/[\xD9-\xDC]/g, "U").replace(/[\xDD]/g, "Y").replace(/[\xDE]/g, "P").replace(/[\xE0-\xE5]/g, "a").replace(/[\xE6]/g, "ae").replace(/[\xE7]/g, "c").replace(/[\xE8-\xEB]/g, "e").replace(/[\xEC-\xEF]/g, "i").replace(/[\xF1]/g, "n").replace(/[\xF2-\xF6\xF8]/g, "o").replace(/[\xF9-\xFC]/g, "u").replace(/[\xFE]/g, "p").replace(/[\xFD\xFF]/g, "y")), e;
    }
  }, {
    key: "isEmpty",
    value: function value(e) {
      return null == e || "" === e || Array.isArray(e) && 0 === e.length || !(e instanceof Date) && "object" == typeof e && 0 === Object.keys(e).length;
    }
  }, {
    key: "isNotEmpty",
    value: function value(e) {
      return !this.isEmpty(e);
    }
  }, {
    key: "isNil",
    value: function value(e) {
      return null == e;
    }
  }, {
    key: "isObjectAndContainsKey",
    value: function value(e, r) {
      return "object" == typeof e && null !== e && Object.hasOwn(e, r) && !Array.isArray(e);
    }
  }], function (e, r) {
    for (var t = 0; t < r.length; t++) {
      var n = r[t];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }(n, e), n;
}();
export { n as default };